import Vue from 'vue';
import Router from 'vue-router';
// import VueAnalytics from 'vue-analytics';
import FourOhFour from './views/FourOhFour.vue';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: () =>
        import( /* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/cases',
      name: 'works',
      component: () =>
        import( /* webpackChunkName: "works" */ './views/Works.vue')
    },
    {
      path: '/about-page-dev',
      name: 'about',
      component: () =>
        import ( /* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () =>
        import( /* webpackChunkName: "contacts" */ './views/Contact.vue')
    },
    // NOTE: sandbox is currently outdated, will fix this "some day ;/" / erik
    // {
    //   path: '/sandbox',
    //   name: 'sandbox',
    //   component: () =>
    //     import ( /* webpackChunkName: "sandbox" */ './views/Sandbox.vue')
    // },
    {
      path: '/404',
      component: FourOhFour
    },
    {
      path: '/case/:url',
      name: 'case',
      component: () =>
        import( /* webpackChunkName: "case" */ './views/Case.vue'),
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

// Vue.use(VueAnalytics, {
//   id: 'UA-43070379-2',
//   router,
//   debug: {
//     sendHitTask: process.env.NODE_ENV === 'production'
//   }
// })


export default router;
